import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '../auth'
import { Spinner } from '../components/ui'

/**
 * Everything behind sign-in. Users with an authenticator must enter a code on each new
 * session before anything else; platform admins must set one up before they can proceed.
 */
export function RequireSignIn() {
  const { me, loading } = useAuth()
  const location = useLocation()
  if (loading) return <Spinner />
  if (!me) return <Navigate to={`/sign-in?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />
  const onMfa = location.pathname === '/mfa'
  if ((me.mfaRequired || me.mfaSetupRequired) && !onMfa) return <Navigate to={`/mfa?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />
  return <Outlet />
}
